import {
  createApi,
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";

import { generateSEKAndHash } from "./crypto";
import { API_URL } from "../constants/urls";
import { getFromStorage, removeFromStorage } from "../helpers";
import { STORAGE_KEYS } from "../constants/storageKeys";
import { RootState } from "../app/store";
import { resetAuth } from "../reducers/authSlice";

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  prepareHeaders: (headers, { getState }) => {
    const { token } = (getState() as RootState).auth;
    const tokenFromLocal = getFromStorage(STORAGE_KEYS.token);
    const tempToken = getFromStorage(STORAGE_KEYS.tempToken);

    const encryptData = generateSEKAndHash(
      tempToken || tokenFromLocal || token || null
    );

    if (encryptData) {
      headers.set("hash", encryptData?.hash);
      headers.set("sek", encryptData?.sek);
    }
    headers.set("deviceType", "web");
    headers.set("lang", "en");

    return headers;
  },
});

const baseQueryWithAuth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {

  const result = await baseQuery(args, api, extraOptions);
  if (result?.error?.status === 400) {
    const errors = Object.values(result?.error?.data || {});
    if (errors?.length > 1 && errors[1] === 400) {
      return result;
    }

   
  }

  if (result.error?.status === 401) {
    api.dispatch(resetAuth());
    if (window) {
      window.location.replace("/");
      removeFromStorage(STORAGE_KEYS.tempToken);
      removeFromStorage(STORAGE_KEYS.token);
    }
  }

  return result;
};

const emptySplitApi = createApi({
  baseQuery: baseQueryWithAuth,
  tagTypes: ["UNAUTHORIZED", "UNKNOWN_ERROR"],
  endpoints: () => ({}),
});

export default emptySplitApi;
